import React from 'react';
import { Helmet } from "react-helmet";

const HeadMeta = props => {
    const {
        title, description,
        ogUrl, ogType, ogTitle, ogDescription, ogImage
    } = props;

    return (
        <Helmet> 
            { title && <title>{title}</title> }
            { description && <meta name="description" content={description} /> }

            { ogUrl && <meta property="og:url" content={ogUrl} /> }
            { ogType && <meta property="og:type" content={ogType} /> }
            { ogTitle && <meta property="og:title" content={ogTitle} /> }
            { ogDescription && <meta property="og:description" content={ogDescription} /> }
            { ogImage && <meta property="og:image" content={ogImage} /> }
        </Helmet>
    )
}

export default HeadMeta;


// WEBPACK FOOTER //
// ./src/partials/HeadMeta.js